import React from 'react';
import { Badge } from 'reactstrap';

import { PaymentLookupStatus } from '~direct-debits/models';

interface ComponentProps {
  // Accept either a row carrying `status` (table-view-v3 custom cell shape) or
  // a direct status prop. Either form may be null/undefined when the API has
  // no status to report (e.g. a payment row that has not started processing).
  row?: { status: PaymentLookupStatus | null | undefined };
  status?: PaymentLookupStatus | null;
}

// Lookup-driven badge mirroring the mandates implementation: the API enriches
// each entity with `status: { tag, name, colour }`, and the badge applies the
// supplied hex colour directly. Adding a new payment status is a server-side
// migration concern, not a UI change.
const PaymentStatusBadge: React.FC<ComponentProps> = ({ row, status }) => {
  const value = row?.status ?? status ?? null;

  if (!value) {
    return (
      <Badge color="secondary" data-cy="dd-payment-status-none">
        —
      </Badge>
    );
  }

  const { tag, name, colour } = value;
  // Tolerate either form from the API (`abc123` or `#abc123`) — without this,
  // a leading `#` would produce a malformed `##abc123` CSS value.
  const backgroundColor = colour.startsWith('#') ? colour : `#${colour}`;
  return (
    <Badge style={{ backgroundColor }} data-cy={`dd-payment-status-${tag}`}>
      {name}
    </Badge>
  );
};

export default PaymentStatusBadge;
